import React from 'react';
import { FormControl, FormControlLabel, FormHelperText, Switch} from '@material-ui/core';
import {withFormsy} from 'formsy-react';
import { withStyles } from '@material-ui/core/styles';
import _ from '@lodash';

function SwitchFormsy(props)
{
    const importedProps = _.pick(props, [
        'checkedIcon',
        'classes',
        'color',
        'disabled',
        'disableRipple',
        'icon',
        'id',
        'indeterminate',
        'indeterminateIcon',
        'inputProps',
        'inputRef',
        'onChange',
        'variant',
    ]);

    // An error message is returned only if the component is invalid
    const errorMessage = props.errorMessage;
    const value = props.value;

    function changeValue(event)
    {
        props.setValue(event.target.checked);
        if ( props.onChange )
        {
            props.onChange(event);
        }
    }

    return (
        <FormControl error={Boolean(errorMessage)} className={props.className}>
            <FormControlLabel
                control={
                    <Switch
                        size="normal"
                        focusVisibleClassName={props.classes.focusVisible}
                        disableRipple
                        classes={{
                            root: props.classes.root,
                            switchBase: props.classes.switchBase,
                            thumb: props.classes.thumb,
                            track: props.classes.track,
                            checked: props.classes.checked,
                        }}
                        {...props}
                        checked={value}
                        onChange={changeValue}
                        {...importedProps}
                        />
                }
                label={props.label}
                labelPlacement={props.labelPlacement}
            />
            {Boolean(errorMessage) && (
                <FormHelperText>{errorMessage}</FormHelperText>
            )}
        </FormControl>
    );
}

export default React.memo(withFormsy(withStyles(theme => ({
    labelSwitch: {
    },
    root: {
      width: 60,
      height: 32,
      padding: 0,
      '& .MuiSwitch-colorSecondary.Mui-disabled + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.grey.veryLight,
      },
      '& .MuiSwitch-thumb': {
        backgroundColor: theme.palette.common.white,
      },
      '& .MuiSwitch-thumb, & .Mui-check ': {
        backgroundColor: theme.palette.common.white,
      },
      '& .Mui-disabled .MuiSwitch-thumb': {
        backgroundColor: theme.palette.grey.veryLight,
      },
      '& .MuiSwitch-track': {
        backgroundColor: theme.palette.grey.veryLight,
      },
    },
    switchBase: {
      padding: 4,
      '&$checked': {
        transform: 'translateX(26px)',
        '& + $track': {
          backgroundColor: theme.palette.active.main,
          opacity: 1,
          border: 'none',
        },
      },
      '&$focusVisible $thumb': {
        color: theme.palette.active.main,
        border: '6px solid #fff',
      },
    },
    thumb: {
      width: 24,
      height: 24,
      backgroundColor: '#fff',
    },
    track: {
      borderRadius: 32 / 2,
      opacity: 1,
      backgroundColor: theme.palette.grey.veryLight,
      transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
  }))(SwitchFormsy)));
